import type {ReactAction} from '@netx/core/bootstrap';
import {faArrowUpFromBracket} from '@netx/core-icons';
import {type ICategory} from '@netx/core-category-next/schema';
import {UploadAssetEvent} from '@netx/core-upload-asset/actions';
import {canImportToCategory} from '../enablers';
import {CategoryActionLabel} from '../locales';

export const categoryActionImportIcon = faArrowUpFromBracket;

/**
 * Import to category
 * @param params
 * @returns Action
 */
export const categoryActionImport = (
	category?: ICategory,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'category-import',
	cb: () => dispatcher.trigger(UploadAssetEvent.UPLOAD, category?.categoryid),
	enableTest: () => canImportToCategory(category),
	icon: categoryActionImportIcon,
	get label() {
		return CategoryActionLabel.IMPORT;
	},
	...params,
});

export default categoryActionImport;
